import React, { useEffect, useState } from "react";
import TopNav from "../layouts/TopNav";
import "../Styles/invoiceTable.css";
import { ToastContainer, toast } from "react-toastify";
import TablePagination from "@mui/material/TablePagination";
import { useNavigate } from "react-router-dom";
import ReLoginModal from "../components/ReLoginModal";
import SuperStaffModal from "../components/Modals/PermissionModal.tsx/SuperStaffModal";
import { BiArrowBack } from "react-icons/bi";
import { CircularProgress } from "@mui/material";
import api from "../util/axios";

type Staff = {
  _id: string;
  loadingSlip: any;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  account: any;
  referralCode: string;
  businessType: string;
};

const SuperStaff = () => {
  const token = window.localStorage.getItem("token");
  const [getStaff, setgetStaff] = useState<Staff[]>([]);
  const [reLogin, setReLogin] = useState(false);
  const [loading, setLoading] = useState(false);

  function queryCustomer() {
    setLoading(true);
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    return api
      .get("/staff", {
        headers: headers,
      })
      .then((res) => {
        const seniorStaff = res.data.data.filter(
          (res: any) => res?.account.role === "seniorStaff"
        );
        setgetStaff(seniorStaff);
        setLoading(false);
      })
      .catch((error) => {
        if (
          error.response.data.message === "jwt expired" ||
          error.response.data.message === "jwt malformed"
        ) {
          toast.error('Session expired, please log in again.');
          setReLogin(true);
        } else {
          setReLogin(false);
          setLoading(false);
          toast.error(error.response.data.message || "An error occurred");
        }
      });
  }

  useEffect(() => {
    queryCustomer();
  }, []);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [modal, setModal] = useState(false);

  const openModal = () => {
    setModal(!modal);
  };
  const navigate = useNavigate();

  return (
    <div className="board">
      <ToastContainer />
      <TopNav title="Super Staff" />

      {reLogin ? <ReLoginModal /> : null}

      <div className="userPro">
        <button onClick={(() => navigate(-1))} className="flex items-center cursor-pointer bg-red-400 hover:bg-red-500 text-white gap-2 py-1 px-10 rounded-lg"><BiArrowBack /> Back</button>
        <div className="invoiceTable">
          {loading ? (
            <div style={{ textAlign: 'center', padding: '20px' }}>
              <CircularProgress />
              <h2>Please wait while we process the request...</h2>
            </div>
          ) : (
            <table className="inTable">
              <tr className="heTble tabHead">
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Role</th>
                <th>Active</th>
              </tr>

              {getStaff
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((staff, inx) => {
                  const active = staff?.account.isActive.toString();
                  return (
                    <>
                      <tr key={inx} className="taData">
                        <td>{staff?.firstName}</td>
                        <td>{staff?.lastName}</td>
                        <td>{staff?.email}</td>
                        <td>{staff?.phone}</td>
                        <td>{staff?.account.role}</td>
                        <td>{active}</td>
                      </tr>
                    </>
                  );
                })}
            </table>
          )}
        </div>

        <TablePagination
          rowsPerPageOptions={[15, 25, 50]}
          component="div"
          count={getStaff.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        <p className="view" onClick={openModal}>
          View User Permissions
        </p>

        {modal ? <SuperStaffModal openModal={openModal} /> : null}
      </div>
    </div>
  );
};

export default SuperStaff;
